import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

export const SignUpCarouselTipsWrapper = styled(Grid)(() => ({
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
}));
